import throttle from 'lodash/throttle'
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks as clearScrollLocks } from 'body-scroll-lock'
import domReady from '../utils/domReady.js'

domReady(() => {
  // Set tabindex to -1 to hide navigation links from keyboard unless invoked.
  const fullNavLinks = document.querySelectorAll('.full-navigation a')
  const searchInput = document.getElementById('searchInput')
  const searchInputSubmit = document.querySelectorAll("label[for='searchFormSubmit']")
  const menuToggle = document.querySelector('#menu-toggle')
  const menuEl = document.querySelector('.full-navigation')
  const searchToggle = document.querySelector('#search-toggle')
  const searchEl = document.querySelector('.searchform')

  if (!menuToggle || !menuEl || !searchToggle || !searchEl) {
    console.error('nav.js: Required navigation elements not found', {
      menuToggle: !!menuToggle,
      menuEl: !!menuEl,
      searchToggle: !!searchToggle,
      searchEl: !!searchEl
    })
    return
  }

  const sweepHiddenNav = () => {
    fullNavLinks.forEach((element) => {
      element.tabIndex = -1
    })
    if (searchInput) searchInput.tabIndex = -1
    if (searchInputSubmit) searchInputSubmit.tabIndex = -1
  }

  sweepHiddenNav()

  const restoreHiddenNav = () => {
    fullNavLinks.forEach((element) => {
      element.removeAttribute('tabindex')
    })
  }

  // Add an active class to nav item on click before transition loads
  const siteNavigation = document.querySelectorAll('.site-navigation a')
  siteNavigation.forEach((element) => {
    element.addEventListener('click', () => {
      siteNavigation.forEach((element) => {
        element.classList.remove('nav-active')
      })
      element.classList.add('nav-active')
    })
  })

  // Nav menu buttons
  const closeMenu = () => {
    enableBodyScroll(menuEl)
    sweepHiddenNav()
    menuToggle.setAttribute('aria-expanded', false)
    menuEl.setAttribute('aria-hidden', true)
    document.body.classList.add('menu-unloading')
    setTimeout(() => {
      document.body.classList.remove('menu-open', 'menu-unloading')
    }, 300)
    menuToggle.focus()
  }

  const closeSearch = () => {
    sweepHiddenNav()
    searchToggle.setAttribute('aria-expanded', false)
    searchEl.setAttribute('aria-hidden', true)
    document.body.classList.remove('search-open')
    searchToggle.focus()
    enableBodyScroll(menuEl)
  }

  menuToggle.addEventListener('click', function () {
    closeSearch()
    if (document.body.classList.contains('menu-open')) {
      closeMenu()
    } else {
      disableBodyScroll(menuEl)
      restoreHiddenNav()
      document.body.classList.add('menu-open')
      menuToggle.setAttribute('aria-expanded', true)
      menuEl.setAttribute('aria-hidden', false)
      const firstMenuItem = document.querySelector('.full-navigation a')
      if (firstMenuItem !== null) { firstMenuItem.focus() };
    }
  })

  searchToggle.addEventListener('click', function () {
    closeMenu()

    if (document.body.classList.contains('search-open')) {
      closeSearch()
    } else {
      searchToggle.setAttribute('aria-expanded', true)
      searchEl.setAttribute('aria-hidden', false)
      disableBodyScroll(menuEl)
      document.body.classList.add('search-open')
      if (searchInput) {
        searchInput.focus()
        searchInput.tabIndex = 1
      }
      if (searchInputSubmit[0]) searchInputSubmit[0].tabIndex = 1
    }
  })

  const escapeMenus = (evt) => {
    evt = evt || window.event
    let isEscape = false
    if ('key' in evt) {
      isEscape = (evt.key === 'Escape' || evt.key === 'Esc')
    } else {
      isEscape = (evt.keyCode === 27)
    }
    if (isEscape) {
      if (document.body.classList.contains('search-open')) {
        closeSearch()
      } else if (document.body.classList.contains('menu-open')) {
        closeMenu()
      }
    }
  }
  window.addEventListener('keydown', escapeMenus)

  const submitSearch = (evt) => {
    evt = evt || window.event
    let isSubmit = false
    if ('key' in evt) {
      isSubmit = (evt.key === 'Return' || evt.key === 'Enter' || evt.keyCode === 13)
    }
    if (isSubmit) {
      if (document.body.classList.contains('search-open')) {
        document.forms.searchform.submit()
      }
    }
  }
  window.addEventListener('keydown', submitSearch)

  let menuScrollPos = 0
  menuEl.onscroll = throttle(() => {
    const updatedScrollPos = menuEl.scrollTop

    if (menuEl.scrollTop > menuScrollPos && menuEl.scrollTop > 25 && !document.body.classList.contains('menuScrolling')) {
      document.body.classList.add('menuScrolling')
    }
    if (menuEl.scrollTop < menuScrollPos && menuEl.scrollTop < 25 && document.body.classList.contains('menuScrolling')) {
      document.body.classList.remove('menuScrolling')
    }

    menuScrollPos = updatedScrollPos <= 0 ? 0 : updatedScrollPos
  }, 100)

  /* Scrolled Header */
  {
    let scrollpos = window.scrollY
    const header = document.querySelector('.site-header')
    if (!header) return

    const addClassOnScroll = () => {
      header.classList.add('scrolledHeader', 'med-bg', 'transitionIn')
      document.body.classList.add('scrolledHeader')
      setTimeout(() => {
        header.classList.remove('transitionIn')
      }, 300)

      scrollpos = window.scrollY
    }
    const removeClassOnScroll = () => {
      header.classList.add('transitionOut')
      setTimeout(() => {
        header.classList.remove('scrolledHeader', 'transitionOut')
        document.body.classList.remove('scrolledHeader', 'med-bg')
      }, 150)
      scrollpos = window.scrollY
    }
    window.onscroll = throttle(() => {
      const newpos = window.scrollY
      if (newpos >= 250 && !header.classList.contains('scrolledHeader')) {
        addClassOnScroll()
      } else if (newpos < 250 && newpos < scrollpos && header.classList.contains('scrolledHeader')) {
        removeClassOnScroll()
      }
    }, 200)
  }

  clearScrollLocks()
})
